import { Tooltip } from "@mui/material";
import { getAPIBaseUrl, isAdmin } from "../../../../utils/constants";
import { TooltipName } from "../../../../utils/Enums";
import Admin from "./Admin";
import Logs from "./Logs";
import Team from "./Team";
import UserName from "./UserName";
import Active from "./Active";
import { relativeTime } from "../../../../utils";
import Avtar from "../../../../components/Avatar";
import Action from "./Action";

export const userManagementColumns = (icon) => {
  const apiUrl = getAPIBaseUrl();

  return [
    {
      field: "user_type",
      headerName: "Type",
      minWidth: 80,
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p className="size-14 text-color weight-500">Type</p>
        </div>
      ),
      headerClassName: "center-header",
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex justify-content-center">
            {icon ? (
              <>
                <Avtar
                  user_image={`${apiUrl}/${icon}`}
                  unassigned={true}
                  title={
                    params?.value == "Internal"
                      ? TooltipName.MANAGE_USER.INTERNAL_USER
                      : TooltipName.MANAGE_USER.EXTERNAL_USER
                  }
                  className={
                    params?.value == "Internal"
                      ? "internal_user_icon"
                      : "external_user_icon"
                  }
                />
              </>
            ) : (
              params.value
            )}
          </div>
        );
      },
      flex: 0.6,
      sortable: false,
    },
    {
      field: "first_name",
      headerName: "Name",
      minWidth: 250,
      flex: 1.5,
      renderCell: (params) => {
        return <UserName params={params} />;
      },
    },
    {
      field: "teams",
      headerName: "Team",
      minWidth: 150,
      renderCell: (params) => {
        return <Team params={params} />;
      },
      flex: 1,
      sortable: false,
    },
    {
      field: "cardlog_required",
      headerName: "Logs",
      minWidth: 100,
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p className="size-14 text-color weight-500">Logs</p>
        </div>
      ),
      renderCell: (params) => {
        return <Logs logRequired={params.value} params={params} />;
      },
      flex: 0.7,
      sortable: false,
      headerClassName: "center-header",
    },
    {
      field: "role",
      headerName: "Admin",
      minWidth: 100,
      renderHeader: (cell) => (
        <div className="w-100 d-flex justify-content-center">
          <p className="size-14 text-color weight-500">Admin</p>
        </div>
      ),
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex justify-content-center">
            {isAdmin() && (
              <Admin isSuperAdmin={params.value} userId={params.row.user_id} />
            )}
          </div>
        );
      },
      headerClassName: "center-header",
      flex: 1,
      sortable: false,
    },
    // {
    //   field: "active",
    //   headerName: "Active",
    //   minWidth: 85,
    //   renderHeader: (cell) => (
    //     <div className="w-100 d-flex justify-content-center">
    //       <p className="size-14 text-color weight-500">Active</p>
    //     </div>
    //   ),
    //   renderCell: (params) => {
    //     return <Active isActive={params.value} userId={params.row.user_id} />;
    //   },
    //   flex: 1,
    //   sortable: false,
    //   headerClassName: "center-header",
    // },
    {
      field: "last_seen",
      headerName: "Last Active",
      minWidth: 100,
      renderCell: (params) => {
        return <p>{relativeTime(params.value)}</p>;
      },
      flex: 1.2,
      sortable: false,
    },
    {
      field: "action",
      headerName: "",
      minWidth: 80,
      renderCell: (params) => {
        return  <Action params={params} />;
      },
      flex: 0.5,
      sortable: false,
    },
  ];
};
